/**
 * Version telemetry — logs the active app version to audit_log
 * so we can detect users stuck on old versions.
 */
import { supabase } from "@/integrations/supabase/client";
import { APP_BUILD_VERSION } from "./appVersion";

const TELEMETRY_KEY = "vantastika_version_reported";
const REPORT_INTERVAL_MS = 4 * 60 * 60 * 1000; // report at most every 4 hours

export async function reportVersionTelemetry(): Promise<void> {
  try {
    const last = localStorage.getItem(TELEMETRY_KEY);
    if (last && Date.now() - Number(last) < REPORT_INTERVAL_MS) return;

    const { data: { session } } = await supabase.auth.getSession();
    const userId = session?.user?.id ?? null;

    // Get SW state
    let swState = "none";
    if ("serviceWorker" in navigator) {
      const reg = await navigator.serviceWorker.getRegistration();
      if (reg) {
        if (reg.waiting) swState = "waiting";
        else if (reg.active) swState = "active";
        else if (reg.installing) swState = "installing";
      }
    }

    await supabase.rpc("write_audit_log", {
      _user_id: userId,
      _action: "version_check",
      _resource_type: "app_version",
      _resource_id: APP_BUILD_VERSION,
      _ip_address: null,
      _details: {
        build: APP_BUILD_VERSION,
        sw_state: swState,
        user_agent: navigator.userAgent.slice(0, 120),
        standalone: window.matchMedia("(display-mode: standalone)").matches,
      },
    });

    localStorage.setItem(TELEMETRY_KEY, String(Date.now()));
  } catch {
    // telemetry is best-effort
  }
}
